import { Component, ViewChild, OnInit, ElementRef, AfterViewInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { AppService } from '../app.service';




declare const WebViewer: any;

@Component({
  selector: 'web-viewer',
  templateUrl: './webviewer.component.html',
  styleUrls: ['./webviewer.component.css']
})
export class WebViewerComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('viewer', { static: false }) viewer: ElementRef;
  @ViewChild('viewer') viewer1: ElementRef; // ✅ kept for backward compatibility

  @Input() data: any = {};
  wvInstance: any;
  viewInitialized = false;
  private isDocLoading = false;
  private readonly printBlockHandler: ((e: KeyboardEvent) => void) | null = null;

  constructor(private readonly appService: AppService) { }

  ngOnInit() {
    this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
  }

  @Output() oneQmsListener = new EventEmitter<void>();


  ngAfterViewInit(): void {

    this.viewInitialized = true;

    // ✅ Initialize WebViewer ONLY once
    if (!this.wvInstance) {
      WebViewer(
        {
          path: '../../wv-resources/lib',
          licenseKey:
            'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7',
          fullAPI: true,
          disableLogs: true,
          webViewerServer: true,
          disabledElements: [
            'leftPanelButton',
            'toolbarGroup-Annotate',
            'highlightToolGroupButton',
            'underlineToolGroupButton',
            'strikeoutToolGroupButton',
            'squigglyToolGroupButton',
            'freeTextToolGroupButton',
            'shapeToolGroupButton',
            'stickyToolGroupButton',
            'freeHandToolGroupButton',
            'toolsOverlay',
            'eraserToolButton',
            'redoButton',
            'stickyToolButton',
            'textPopup',
            'toggleNotesButton',
            'selectToolButton',
            'highlightToolButton',
            'freeHandToolButton',
            'freeTextToolButton',
            'toolsHeader',
            'printButton',
          ]
        },
        this.viewer.nativeElement
      ).then((instance: any) => {

        this.wvInstance = instance;
        // Disable the print feature completely
        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        instance.UI.addEventListener(
          instance.UI.Events.KEY_DOWN,
          (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'p') {
              e.preventDefault();
              e.stopPropagation();
              alert('Printing is disabled.');
            }
          }
        );
        // 🔧 Original configuration retained
        instance.UI.setTheme('dark');
        instance.UI.disableElements([
          'toolbarGroup-Shapes',
          'toolbarGroup-View',
          'toolbarGroup-FillAndSign',
          'toolbarGroup-Forms',
          'toolbarGroup-Edit',
          'toolbarGroup-Insert',
          'menuButton',
          'undoButton',
          'highlightToolGroupButton'
        ]);

        const { documentViewer } = instance.Core;

        documentViewer.addEventListener('documentLoaded', () => {
          this.wvDocumentLoadedHandler();
          this.registerActivityListeners(instance);
        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, (err: any) => {
          console.error('Load Error:', err);
        });
        // ✅ If data already available, load immediately
        if (this.data?.body) {
          this.loadDataInViewer(this.data.body, this.data.contentType, this.data.extn);
        }
      });

    } else if (this.data?.body) {
      // If already initialized, just reload
      this.loadDataInViewer(this.data.body, this.data.contentType, this.data.extn);
    }
  }
  ngOnChanges(): void {
    if (!this.viewInitialized || !this.wvInstance || !this.data?.body) {
      return;
    }

    this.loadDataInViewer(this.data.body, this.data.contentType, this.data.extn);
  }

  wvDocumentLoadedHandler(): void {
    console.log('Document fully loaded');
    this.isDocLoading = false;
  }

  loadDataInViewer(data: any, contentType: string, extension: string): void {
    if (!this.wvInstance?.UI || this.isDocLoading) {
      return;
    }

    this.isDocLoading = true;

    const load = (blob: Blob) => {
      this.wvInstance.UI.loadDocument(blob, { extension });
    };

    if (typeof data === 'string') {
      // Convert Base64 string directly to Blob to comply with Content Security Policy (CSP)
      const blob = this.base64ToBlob(data, contentType);
      load(blob);
    } else if (data instanceof Blob || data instanceof File) {
      load(data);
    } else {
      this.isDocLoading = false;
      console.error('Unsupported document data format:', data);
    }
  }

  private base64ToBlob(base64Data: string, contentType: string = 'application/pdf'): Blob {
    // 1. Remove data URL prefix if present (e.g., "data:application/pdf;base64,")
    const cleanBase64 = base64Data.replace(/^data:[^;]+;base64,/, '');

    // 2. Decode base64 to binary string
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    // 3. Return native Blob created directly in JS memory (CSP safe!)
    return new Blob([byteNumbers.buffer as ArrayBuffer], { type: contentType });
  }

  private registerActivityListeners(instance: any): void {
    const iframeWindow = instance.UI.iframeWindow;
    if (!iframeWindow) return;

    const activityHandler = () => this.emitActivity();

    // Mouse & keyboard
    iframeWindow.addEventListener('mousemove', activityHandler, { passive: true });
    iframeWindow.addEventListener('mousedown', activityHandler, { passive: true });
    iframeWindow.addEventListener('wheel', activityHandler, { passive: true });
    iframeWindow.addEventListener('keydown', activityHandler);
    // Scroll inside iframe document
    iframeWindow.document.addEventListener('scroll', activityHandler, { passive: true });
  }


  private emitActivity(): void {
    if (!this.isDocLoading && this.wvInstance) {
      this.oneQmsListener.emit();
    }
  }

}
